
      (function () {
        var body = document.body;
        var toggle = document.querySelector(".menu-toggle");
        var drawer = document.getElementById("drawer");

        function setNav(open) {
          body.classList.toggle("nav-open", open);
          toggle.setAttribute("aria-expanded", open ? "true" : "false");
          toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
          if (open) drawer.removeAttribute("hidden");
          else drawer.setAttribute("hidden", "");
        }

        if (toggle && drawer) {
        toggle.addEventListener("click", function () {
          setNav(!body.classList.contains("nav-open"));
        });
        drawer.querySelectorAll("a").forEach(function (link) {
          link.addEventListener("click", function () { setNav(false); });
        });
        }

        var shopToggle = drawer ? drawer.querySelector(".drawer-shop") : null;
        var shopMenu = document.getElementById("drawer-shop-menu");
        if (shopToggle && shopMenu) shopToggle.addEventListener("click", function () {
          var open = shopToggle.getAttribute("aria-expanded") !== "true";
          shopToggle.setAttribute("aria-expanded", open ? "true" : "false");
          shopMenu.classList.toggle("is-open", open);
        });

        var form = document.getElementById("signup");
        var note = document.getElementById("signup-note");
        if (form && note) form.addEventListener("submit", function (e) {
          e.preventDefault();
          note.classList.add("is-on");
          form.reset();
        });

        /* Trust bar: fade the current message out, then fade the next one in */
        /* Hero split: auto-rotating slider between the Shanti Lilac shots.
           A clone of the first slide is appended so the track always slides
           forward; landing on the clone snaps invisibly back to the start
           (same seamless-loop technique as the adwahermi gallery). */
        var sliderTrack = document.querySelector(".hero-slider");
        if (sliderTrack && sliderTrack.children.length > 1) {
          var realCount = sliderTrack.children.length;
          var firstClone = sliderTrack.children[0].cloneNode(true);
          firstClone.setAttribute("aria-hidden", "true");
          sliderTrack.appendChild(firstClone);

          var dots = document.querySelectorAll(".hero-dots button");
          var slideIdx = 0;
          var sliderTimer;
          var wrapping = false;

          var render = function (animate) {
            if (!animate) sliderTrack.style.transition = "none";
            sliderTrack.style.transform = "translateX(-" + slideIdx * 100 + "%)";
            if (!animate) {
              void sliderTrack.offsetWidth; /* flush styles so the jump isn't animated */
              sliderTrack.style.transition = "";
            }
            dots.forEach(function (dot, i) {
              dot.classList.toggle("is-active", i === slideIdx % realCount);
            });
          };

          var goToSlide = function (n) {
            if (wrapping) return;
            slideIdx = n;
            render(true);
            if (slideIdx === realCount) {
              /* we slid onto the clone — once the motion ends, snap back to slide 0 */
              wrapping = true;
              var fallback;
              var done = function (e) {
                if (e && (e.target !== sliderTrack || e.propertyName !== "transform")) return;
                sliderTrack.removeEventListener("transitionend", done);
                clearTimeout(fallback);
                slideIdx = 0;
                render(false);
                wrapping = false;
              };
              sliderTrack.addEventListener("transitionend", done);
              fallback = setTimeout(done, 800); /* safety net if transitionend never fires */
            }
          };

          var playSlider = function () {
            clearInterval(sliderTimer);
            sliderTimer = setInterval(function () { goToSlide(slideIdx + 1); }, 5000);
          };

          dots.forEach(function (dot, i) {
            dot.addEventListener("click", function () {
              if (wrapping) return;
              goToSlide(i);
              playSlider(); /* restart the clock after a manual switch */
            });
          });

          /* Drag to slide: the track follows the pointer, then settles on the
             nearest slide. Dragging back from the first slide hops through the
             clone so there is always an image to pull in. */
          var dragging = false;
          var dragMoved = false;
          var dragStartX = 0;
          var basePx = 0;
          var lastPx = 0;

          sliderTrack.addEventListener("pointerdown", function (e) {
            if (wrapping) return;
            dragging = true;
            dragMoved = false;
            dragStartX = e.clientX;
            basePx = -slideIdx * sliderTrack.offsetWidth;
            lastPx = basePx;
            sliderTrack.classList.add("is-dragging");
            try { sliderTrack.setPointerCapture(e.pointerId); } catch (err) {}
            clearInterval(sliderTimer); /* don't auto-advance mid-drag */
          });

          sliderTrack.addEventListener("pointermove", function (e) {
            if (!dragging) return;
            var width = sliderTrack.offsetWidth;
            var dx = e.clientX - dragStartX;
            if (!dragMoved && Math.abs(dx) > 3) dragMoved = true;
            if (dx > 0 && basePx === 0) {
              /* pulling backwards from slide 0: jump to the identical clone */
              basePx = -realCount * width;
            }
            lastPx = Math.min(0, Math.max(-realCount * width, basePx + dx));
            sliderTrack.style.transform = "translateX(" + lastPx + "px)";
          });

          var endDrag = function () {
            if (!dragging) return;
            dragging = false;
            sliderTrack.classList.remove("is-dragging");
            var width = sliderTrack.offsetWidth;
            var dx = lastPx - basePx;
            var raw = -lastPx / width;
            /* a deliberate pull (>12% of the width) commits to that direction;
               a small nudge settles back to the nearest slide */
            var target = Math.abs(dx) > width * 0.12
              ? (dx < 0 ? Math.ceil(raw) : Math.floor(raw))
              : Math.round(raw);
            goToSlide(Math.max(0, Math.min(realCount, target)));
            playSlider();
          };
          sliderTrack.addEventListener("pointerup", endDrag);
          sliderTrack.addEventListener("pointercancel", endDrag);

          playSlider();
        }

        /* Write-on reveal for script lines when they scroll into view.
           Note: only isIntersecting is safe here — while the line is clip-hidden,
           Chrome reports its intersectionRatio as 0, so ratio thresholds never fire. */
        var reveals = document.querySelectorAll(".script-reveal");
        if ("IntersectionObserver" in window && reveals.length) {
          /* fires once the line is well inside the viewport → play the write-on */
          var showIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) entry.target.classList.add("is-inview");
            });
          }, { rootMargin: "-10% 0px -10% 0px" });
          /* fires when the line is fully off screen → re-arm for the next pass */
          var resetIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) entry.target.classList.remove("is-inview");
            });
          });
          reveals.forEach(function (el) {
            showIO.observe(el);
            resetIO.observe(el);
          });
        } else {
          reveals.forEach(function (el) { el.classList.add("is-inview"); });
        }

        /* Coupon popup: once per browser session, closable via X, backdrop, Esc,
           or the CTA (which then scrolls to the shop) */
        var couponPop = document.getElementById("coupon-pop");
        if (couponPop) {
          var closeCoupon = function () {
            couponPop.hidden = true;
            try { sessionStorage.setItem("ashakiCouponSeen", "1"); } catch (e) {}
          };
          couponPop.querySelectorAll("[data-coupon-close]").forEach(function (el) {
            el.addEventListener("click", closeCoupon);
          });
          document.addEventListener("keydown", function (e) {
            if (e.key === "Escape" && !couponPop.hidden) closeCoupon();
          });
          var couponSeen = false;
          try { couponSeen = sessionStorage.getItem("ashakiCouponSeen") === "1"; } catch (e) {}
          if (!couponSeen) {
            setTimeout(function () {
              couponPop.hidden = false;
              couponPop.querySelector(".coupon-close").focus();
            }, 1200);
          }
        }

        var messages = document.querySelectorAll(".trust-rotator span");
        if (messages.length > 1) {
          var current = 0;
          setInterval(function () {
            messages[current].classList.remove("is-active");
            setTimeout(function () {
              current = (current + 1) % messages.length;
              messages[current].classList.add("is-active");
            }, 650);
          }, 4000);
        }
      })();
    
      /* Live cart count: Pipeline's own updater is tied to its (removed) header
         section, so mirror it here for the AV1 header's Bag link. */
      (function () {
        document.addEventListener("theme:cart:change", function (e) {
          var cart = e.detail && e.detail.cart;
          if (!cart) return;
          document.querySelectorAll("[data-header-cart-count]").forEach(function (el) {
            el.setAttribute("data-header-cart-count", cart.item_count);
            el.textContent = "(" + cart.item_count + ")";
          });
        });
      })();
